import { render } from "./MyNumber.vue?vue&type=template&id=5650c53d&scoped=true"
import script from "./MyNumber.vue?vue&type=script&lang=js"
export * from "./MyNumber.vue?vue&type=script&lang=js"

import "./MyNumber.vue?vue&type=style&index=0&id=5650c53d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5650c53d"]])

export default __exports__